import React, { useState, useEffect } from "react";
import TimelineSidebar from "./components/TimelineSidebar";
import MetricSummary from "./components/MetricSummary";
import Tabs from "./components/Tabs";
import ChartSection from "./components/ChartSection";
import MilestonePanel from "./components/MilestonePanel";
import "./MainApp.css";
import { gql, useLazyQuery } from "@apollo/client";
import EmailRequestComponent from "./components/EmailRequestComponent";
function MainApp() {
  const [timeline, setTimeline] = useState([]);
  const [activeMetric, setActiveMetric] = useState("Heart Rate");
  const [zoomRange, setZoomRange] = useState(null);
  const [selectedTreatmentIndex, setSelectedTreatmentIndex] = useState(null);
  const [milestones, setMilestones] = useState([
    { metric: "Heart Rate", date: "2025-03-20", value: "85", status: "Missed" },
    { metric: "Weight", date: "2025-03-22", value: "72.5", status: "Success" },
  ]);
  const [metricData, setMetricData] = useState({
    "Heart Rate": Array.from({ length: 100 }, (_, i) => ({
      time: i,
      value: Math.floor(50 + 30 * Math.sin(i / 10) + Math.random() * 20),
    })),
    "Weight": Array.from({ length: 100 }, (_, i) => ({
      time: i,
      value: Math.floor(70 + 10 * Math.sin(i / 15) + Math.random() * 5),
    })),
    "BP": Array.from({ length: 100 }, (_, i) => ({
      time: i,
      value: Math.floor(110 + 15 * Math.sin(i / 12) + Math.random() * 10),
    })),
    "PHQ-9 (Depression)": Array.from({ length: 100 }, (_, i) => ({
      time: i,
      value: Math.floor(2 + 5 * Math.sin(i / 8) + Math.random() * 3),
      // PHQ-9 range: 0-27 (higher = more severe)
      // 0-4: None | 5-9: Mild | 10-14: Moderate | 15-19: Moderately Severe | 20-27: Severe
    })),
    "GAD-7 (Anxiety)": Array.from({ length: 100 }, (_, i) => ({
      time: i,
      value: Math.floor(1 + 4 * Math.sin(i / 7) + Math.random() * 2),
      // GAD-7 range: 0-21 (higher = more severe)
      // 0-4: None | 5-9: Mild | 10-14: Moderate | 15-21: Severe
    }))
  });
  const metrics = metricData[activeMetric];
  const [stateParam] = useState(new URLSearchParams(window.location.search).get("state"));

  const [hasAccessQuery, { data: accessData, called, loading }] = useLazyQuery(
    gql`
    query CheckAccess($state: String!) {
      hasAccess(state: $state)
    }
  `
  );

  useEffect(() => {
    if (stateParam) {
      hasAccessQuery({ variables: { state: stateParam } });
    }
  }, [stateParam]);

  useEffect(() => {
    const baseUrl = process.env.REACT_APP_API_BASE_URL;
    const stateParam = new URLSearchParams(window.location.search).get("state");
    const timelineUrl = `${baseUrl}/timeline?state=${stateParam}`;

    fetch(timelineUrl)
      .then((res) => res.json())
      .then((data) => {
        const sorted = data.sort((a, b) => new Date(a.start) - new Date(b.start));
        setTimeline(sorted);
      })
      .catch((err) => {
        console.error("Timeline fetch failed", err);
      });
  }, []);

  const filteredMetrics = zoomRange
    ? metrics.filter((m) => m.time >= zoomRange[0] && m.time <= zoomRange[1])
    : metrics;

  const treatmentSpacing = timeline.map((item, i) => {
    const total = metrics.length;
    const blockSize = total / timeline.length;
    return {
      ...item,
      xStart: Math.floor(i * blockSize),
      xEnd: i === timeline.length - 1 ? metrics.at(-1)?.time : Math.floor((i + 1) * blockSize),
    };
  });

  if (!loading && called && accessData?.hasAccess === false) {
    return (
      <div style={{ padding: "2rem" }}>
        <h2>This patient has not linked their app yet.</h2>
        <EmailRequestComponent state={stateParam} />
      </div>
    );
  }

  return (
    <div className="layout">
      <div className="sidebar-container">
        <TimelineSidebar
          timeline={timeline}
          metrics={metrics}
          setZoomRange={setZoomRange}
          selectedIndex={selectedTreatmentIndex}
          setSelectedIndex={setSelectedTreatmentIndex}
        />
      </div>

      <div className="main-content">
        <div className="dashboard-header">
          <MetricSummary metrics={filteredMetrics} />
          <Tabs
            activeMetric={activeMetric}
            setActiveMetric={setActiveMetric}
            zoomRange={zoomRange}
            setZoomRange={setZoomRange}
            setSelectedTreatmentIndex={setSelectedTreatmentIndex}
          />
        </div>

        <div className="main-metrics-container">
          <div className="chart-tabs-container">
            <ChartSection
              metrics={filteredMetrics}
              treatmentSpacing={treatmentSpacing}
              zoomRange={zoomRange}
              milestones={milestones.filter((m) => m.metric === activeMetric)}
              activeMetric={activeMetric}
            />
          </div>

          <div className="milestone-container">
            <MilestonePanel
              milestones={milestones}
              setMilestones={setMilestones}
              activeMetric={activeMetric}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default MainApp;